module.exports = require("web-vitals/base");